import styled from 'styled-components';

export const DetailContainer = styled.div`
    padding: 40px;
    font-family: Arial, sans-serif;
    max-width: 800px;
    margin: 0 auto;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    border-bottom: 1px solid #ccc;
    padding-bottom: 20px;
    margin-bottom: 20px;

    img {
        height: 70px;
    }

    h2 {
        margin: 0;
    }
`;

export const ProjectInfo = styled.div`
    background-color: #f0f0f0;
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 20px;
`;

export const Section = styled.div`
    background-color: #e0e8f0;
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 20px;

    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
    }

    .grid-item {
        display: flex;
        align-items: center;
    }
`;

export const CheckboxGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
`;

export const Checklist = styled.div`
    background-color: #f0f0f0;
    padding: 20px;
    border-radius: 5px;
    margin-bottom: 20px;

`;

export const ChecklistItem = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
`;

export const ImageGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-top: 20px;
`;

export const Image = styled.img`
    width: 100%;
    height: 150px;
    object-fit: cover;
    border-radius: 5px;
`;

export const PlanImage = styled(Image)`
    width: auto;
    margin: 0 auto;
    display: block;
`;

export const Button = styled.button`
    margin-top: 20px;
    padding: 10px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 3px;
    cursor: pointer;
`;

export const DeleteButton = styled(Button)`
    background-color: #dc3545;

    &:hover {
        background-color: #c82333;
    }
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    margin-bottom: 50px;

    & > * + * {
        margin-left: 10px;
    }
`;
